import { useTheme } from "@mui/material/styles";
import { Box } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { BackgroundColorHandlerFunction } from "./ColorPicker";
import { ColorSwatch } from "./DefaultColors";

export interface RecentColorsProps {
	/** the initial color to be shown as selected by the picker, in hex. A default array is assigned to it during instantiation. */
	colors: string[];

	/** the callback for when the user selects a color. */
	onColorChange: BackgroundColorHandlerFunction;
}

const RecentColors: FunctionComponent<RecentColorsProps> = (props) => {
	const { colors = [ "#fff", "#fff", "#fff", "#fff", "#fff", "#fff", "#fff", "#fff", "#fff", "#fff" ], onColorChange } = props;
	const theme = useTheme();

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
			}}
		>
			{colors.map((swatchColor, index) => (
				<ColorSwatch
					color={swatchColor}
					key={index}
					onColorChange={onColorChange}
					selected={index === 0}
					selectionBorderColor={theme.palette.FocusPrimary}
					sx={{
						margin: "4px",
					}}
				/>
			))}
		</Box>
	);
};

export default RecentColors;
